import { connect } from 'react-redux';
import * as actions from './actions';
import * as selectors from './selectors';
import ConsultationAppointComponent from './component';


const mapStateToProps = (state) => ({
  isPutting: selectors.getIsPutting(state),
  errMsg: selectors.getErrMsg(state),
});

const mapDispatchToProps = dispatch => ({
  onUpdateAppointor: (consultationId, appointDate, name, address, phone, email, relationship, ssid, birthday) => {
    dispatch(actions.doUpdateAppointor(consultationId, appointDate, name, address, phone, email, relationship, ssid, birthday));
  },
   onUpdateCompany: (consultationId, appointDate, name, address, phone, email, ban, representative, contactPerson) => {
    dispatch(actions.doUpdateCompany(consultationId, appointDate, name, address, phone, email, ban, representative, contactPerson));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConsultationAppointComponent);